import { useSelector } from "react-redux";

import { Button } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { useConnectOpenWidget } from "hooks/settings/openwidget/use-connect-openwidget";
import { selectIsAdmin } from "store/entities/agents";

import { SettingsHeader, SettingsParagraph } from "../styled";

import ContentWrapper from "./components/ContentWrapper";
import { NonAdminAlert } from "./components/NonAdminAlert";
import { OpenWidgetPromoVideo } from "./components/OpenWidgetPromoVideo";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const NotConnected = () => {
  const { mutate: connectOpenWidget, isLoading: isConnecting } = useConnectOpenWidget();
  const isOwner = useSelector(selectIsAdmin);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onConnectOpenWidget = () => {
    connectOpenWidget();
    trackEngagement("OpenWidget: Connected", EventPlace.Settings, { inOrganization: true });
  };

  return (
    <ContentWrapper>
      <Block>
        <SettingsHeader>Add a contact widget to your website</SettingsHeader>
        <SettingsParagraph>
          Boost customer engagement by including a contact widget on your website. Effortlessly collect messages and
          keep the conversation going.
        </SettingsParagraph>
        <Button
          kind="primary"
          loading={isConnecting}
          onClick={onConnectOpenWidget}
          disabled={!isOwner}
          data-testid="connect-button"
        >
          Add contact widget
        </Button>
      </Block>
      {!isOwner && <NonAdminAlert />}
      <OpenWidgetPromoVideo />
    </ContentWrapper>
  );
};
